"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMaleModels = void 0;
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const getMaleModels = (state) => {
    return state && state.models.filter(model => model.type === bridge_schema_1.ModelType.Male);
};
exports.getMaleModels = getMaleModels;
